module.exports = __webpack_public_path__ + "media/flags/ht-5fd55b7b.svg";